export default __webpack_public_path__ + "static/media/hotannealed.b500d8f0.jpg";